export default {
  S00GAZ: 'Gaz',
  I00DEBGAZ: 'Débit',
  I00RELGAZPUISS: 'Puissance',
  I00DIMLIGNEGAZ: 'Tuyauterie',

  S01ECS: 'Eau chaude Sanitaire',
  I01TEMPATT: "Temps d'attente ECS",
  I01EVACONSSYSTECS: 'Logements collectif',
  I01EVACONSSYSTECS2: 'Tertiaire collectif',
  I01EVAECSQUALI: 'Logements Collectifs (Qualitel)',
  I01EVAECSQUALI2: 'Résidence étudiantes, jeune travailleur et personnes agées (Qualitel)',
  I01EVAECSQUALI3: 'EHPA et EHPAD collectifs (Qualitel)',
  I01DEPBOUCECS: 'Bouclage ECS',

  S02BILANFINECO: 'Bilan écologique et financier',
  I02CHOIXENERCHAUF: "Choix du type d'Energie pour le chauffage",
  I02COSTENER: "Argus consommation par type d'énergie",

  S03AIR: 'Air',
  I03PSYCHROAIR: "Psychrométrique de l'air",

  S04CHAUDIERE: 'Déperdition bâtiment',
  I04DIMPUISCONS: 'Selon bilan de consommation',
  I04DIMPUISSCHAUD: 'Selon la surface habitable',
  I04CONVVOLENER: 'Convertir un volume combustible en énergie',
  I04CONCLIMCONS: 'Conso climat constant',
  I04CONSCHAUFAN: 'Consommation chauffage mensuelle',
  I04CALCULGSIMP: 'Description simplifiée du G',

  S06DECHYDRO: 'Découplage',
  I06SEPHYD: 'Hydraulique',

  S07RADIATEUR: 'Radiateur',
  I07CALCPUISSRAD: 'Puissance et dimension',

  S08VASEEXPANSION: "Vase d'expansion",
  I08CALCVOLEXP: 'Expansion chauffage',

  S09CIRCULATEUR: 'Circulateur',
  I09DIMCIRC: 'Circulateur',

  S10TUYAUTERIE: 'Tuyauterie',
  I10DIAMPUISS: "Diamètre d'une puissance",
  I10DIABOUCECS: 'Diamètre départ ECS',

  S11PERTECHARGE: 'Pertes de charges',
  I11PERCHADISCHA: 'Linéaire',
  I11PERCHARES: 'Linéaire et Singulière',
  I11PERCHARVARI: 'Variation Perte de charge singulière',

  S12VOLINSTCHAUF: "Volume d'eau",
  I12VOLINSTCHAUF: 'Installation',

  S13CHAUFFERIE: 'Ventilation',
  I13VENTCHAUFFIOUL: 'Chaufferie fioul',
  I13VENTCHAUFGAZ: 'Chaufferie gaz',
  S14VANNE: 'Vanne de régulation',

  I14V3VREGUL: "KVs d'une vanne de régulation",
  I14V2VREGUL: "Perte de charge d'une vanne 2 voies",

  S15BOIS: 'Bois',

  S16TRAITEMENTDEAU: "Traitement d'eau",
  I16DIMADOUCISSEURECS: 'Dimensionnement adoucisseur ECS',
  I16DIMADOUCISSEURPRIM: 'Dimensionnement adoucisseur primaire',

  S17COGENERATION: 'Cogénération',
  I17TARIFC16: "Contrat C16 - Tarif d'achat de l'électricité",
  I17INFPARCONSEP: "Tarif C16 - Influence de la part d'autoconsommation",

  S18VENTILATION: 'Ventilation bâtiment',
  I18VENTGAINE: "Diamètre d'une gaine",

  S21RENDEMENT: 'Efficacité et rendement',
  I21RENDETAS: "ETAS d'une chaudière",
  I15MASVOLAPHUML: "Poids du bois en fonction de l'humidité",
  I15TEMPRELEVE: "Température extérieur de relève de l'appoint",
  I15HYDROACCU: 'Volume hydro accumulation',
  I15TEMPLIMITBOIS: 'Température limite de la chaudière bois',
  I15DIMSILOBOIS: 'Dimensionnement Silo à bois',
  I15TAUXCOUVBOIS: 'Taux de couverture de la biomasse',
  I13VENTCHAUFBOIS: 'Chaufferie bois',
  I10DIAEFCOL: 'Diamètre eau froide collective',
  //[MARKER]
  I04CALCULGDETA: 'Description détaillée du G',
  I04CALCULGDETAItem: ''
}
